import * as React from 'react';

import logoSrc from './logo.svg';

export const CreSpaceLogo: React.FC = () => {
  return <img src={logoSrc} alt="CRE.Space logo" />;
};

CreSpaceLogo.displayName = 'CreSpaceLogo';
